import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Box,
  TextField,
  Stack,
  Grid,
  Typography,
  Paper,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { DataGrid } from "@mui/x-data-grid";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";

export default function StudentUpdate() {
  const user = JSON.parse(sessionStorage.getItem("user"));

  const clientId = user?.client_id;
  const collegeId = user?.college_id;

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [admittedBatches, setAdmittedBatches] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [branches, setBranches] = useState([]);
  const [bulkUpdating, setBulkUpdating] = useState(false);
  const [admittedbatchId, setAdmittedbatchId] = useState("");
  const [programId, setProgramId] = useState("");
  const [branchId, setBranchId] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingStudentId, setEditingStudentId] = useState(null);
  const [rows, setRows] = useState([]);

  const [loading, setLoading] = useState(false);
  const [updatingId, setUpdatingId] = useState(null);

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [searchText, setSearchText] = useState("");
  const [openAddStudent, setOpenAddStudent] = useState(false);
  const [addingStudent, setAddingStudent] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [newStudent, setNewStudent] = useState({
    admittedbatch_id: "",
    program_id: "",
    branch_id: "",

    user_id: "",

    admission_no: "",
    admission_date: "",
    student_rollno: "",
    aadhaar_no: "",

    student_name: "",
    father_name: "",
    mother_name: "",

    dob: "",
    gender: "O",

    email: "",
    mobile: "",
    photo_url: "",
    address: "",

    admission_type: "REGULAR",

    previous_college: "",
    transfer_date: "",
    break_reason: "",

    original_batch_id: "",
    rejoin_batch_id: "",

    transfer_credits: "",

    enroll_status: "ADMITTED",

    is_active: true,

    workflow_status: "APPROVED",

    extra_attributes: {},

    student_status: "ACTIVE",

    second_language: "TELUGU",

    seat_type: "C",

    section: "A",
    nationality: "",
    religion: "",
    caste: "",
    subcaste: "",
  });
  // ---------------------------------------------------------
  // LOAD ADMITTED BATCHES
  // ---------------------------------------------------------

  const nationalityOptions = ["Indian", "Other"];

  const religionOptions = ["Hindu", "Muslim", "Christian", "Sikh", "Buddhist", "Jain", "Other"];

  const casteOptions = ["OC", "BC-A", "BC-B", "BC-C", "BC-D", "BC-E", "SC", "ST", "Other"];

  const subcasteOptions = [
    "Mala",
    "Madiga",
    "Kamma",
    "Kapu",
    "Settibalija",
    "ViswaBrahmin",
    "Brahmin",
    "Muslim",
    "Rajaka",
    "Mangali",
  ];
  const formatDateForInput = (value) => {
    if (!value) return "";

    // Extract YYYY-MM-DD without timezone conversion
    return String(value).substring(0, 10);
  };
  useEffect(() => {
    if (clientId && collegeId) {
      loadAdmittedBatches();
    }
  }, [clientId, collegeId]);
  const handleBulkUpdate = async () => {
    if (!rows.length) {
      showSnackbar("No students available to update", "warning");
      return;
    }

    try {
      setBulkUpdating(true);

      const results = await Promise.allSettled(
        rows.map((row) => {
          const payload = {
            admittedbatch_id: row.admittedbatch_id ? Number(row.admittedbatch_id) : null,
            branch_id: row.branch_id ? Number(row.branch_id) : null,
            admission_no: row.admission_no || null,
            admission_date: row.admission_date
              ? new Date(`${row.admission_date}T00:00:00.000Z`)
              : null,
            student_rollno: row.student_rollno || null,
            aadhaar_no: row.aadhaar_no || null,
            student_name: row.student_name || null,
            father_name: row.father_name || null,
            mother_name: row.mother_name || null,
            dob: row.dob || null,
            gender: row.gender || null,
            email: row.email || null,
            mobile: row.mobile || null,
            address: row.address || null,
            admission_type: row.admission_type || null,
            second_language: row.second_language || null,
            seat_type: row.seat_type || null,
            section: row.section || null,
            student_status: row.student_status || "ACTIVE",
            modified_by: user?.user_email || null,

            // Preserve existing JSON properties and update these four.
            extra_attributes: {
              ...(row.extra_attributes &&
              typeof row.extra_attributes === "object" &&
              !Array.isArray(row.extra_attributes)
                ? row.extra_attributes
                : {}),
              nationality: row.nationality || "",
              religion: row.religion || "",
              caste: row.caste || "",
              subcaste: row.subcaste || "",
            },
          };

          return axios.put(
            `${API_BASE_URL}/api/students/updates/${clientId}/${collegeId}/${row.student_id}`,
            payload
          );
        })
      );

      const succeeded = results.filter(
        (result) => result.status === "fulfilled" && result.value.data?.success
      ).length;

      const failed = results.length - succeeded;

      if (failed === 0) {
        showSnackbar(`Bulk update successful: ${succeeded} students updated`, "success");
      } else {
        showSnackbar(
          `Updated ${succeeded} students; ${failed} failed. Please review and retry.`,
          "warning"
        );
      }
    } catch (error) {
      console.error("Bulk update error:", error);
      showSnackbar("Unable to complete bulk update", "error");
    } finally {
      setBulkUpdating(false);
    }
  };
  const handleNewStudentChange = (field, value) => {
    setNewStudent((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  const showSnackbar = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;

    setSnackbar((prev) => ({
      ...prev,
      open: false,
    }));
  };
  const resetNewStudent = () => {
    setNewStudent({
      admittedbatch_id: "",
      program_id: "",
      branch_id: "",

      user_id: user?.user_id || "",

      admission_no: "",
      admission_date: "",
      student_rollno: "",
      aadhaar_no: "",

      student_name: "",
      father_name: "",
      mother_name: "",

      dob: "",
      gender: "O",

      email: "",
      mobile: "",
      photo_url: "",
      address: "",

      admission_type: "REGULAR",

      previous_college: "",
      transfer_date: "",
      break_reason: "",

      original_batch_id: "",
      rejoin_batch_id: "",

      transfer_credits: "",

      enroll_status: "ADMITTED",

      is_active: true,

      workflow_status: "APPROVED",

      extra_attributes: {},

      student_status: "ACTIVE",

      second_language: "TELUGU",

      seat_type: "C",

      section: "A",
      nationality: "",
      religion: "",
      caste: "",
      subcaste: "",
    });
  };
  const handleOpenAddStudent = () => {
    resetNewStudent();
    setIsEditMode(false);
    setEditingStudentId(null);
    setOpenAddStudent(true);
  };
  const handleEditStudent = (row) => {
    const extraAttributes =
      row.extra_attributes &&
      typeof row.extra_attributes === "object" &&
      !Array.isArray(row.extra_attributes)
        ? row.extra_attributes
        : {};

    setEditingStudentId(row.student_id ?? row.id);

    setIsEditMode(true);

    setNewStudent((prev) => ({
      ...prev,
      ...row,

      admittedbatch_id: String(row.admittedbatch_id ?? ""),
      program_id: String(row.program_id ?? programId ?? ""),
      branch_id: String(row.branch_id ?? branchId ?? ""),

      user_id: String(row.user_id ?? user?.user_id ?? ""),

      admission_no: row.admission_no ?? "",
      admission_date: row.admission_date ? new Date(`${row.admission_date}T00:00:00.000Z`) : null,

      student_rollno: row.student_rollno ?? "",
      aadhaar_no: row.aadhaar_no ?? "",

      student_name: row.student_name ?? "",
      father_name: row.father_name ?? "",
      mother_name: row.mother_name ?? "",

      dob: row.dob ? String(row.dob).substring(0, 10) : "",
      gender: row.gender ?? "O",

      email: row.email ?? "",
      mobile: row.mobile ?? "",
      photo_url: row.photo_url ?? "",
      address: row.address ?? "",

      admission_type: row.admission_type ?? "REGULAR",

      previous_college: row.previous_college ?? "",
      transfer_date: row.transfer_date ? String(row.transfer_date).substring(0, 10) : "",
      break_reason: row.break_reason ?? "",

      original_batch_id: row.original_batch_id ? String(row.original_batch_id) : "",
      rejoin_batch_id: row.rejoin_batch_id ? String(row.rejoin_batch_id) : "",

      transfer_credits: row.transfer_credits ?? "",

      enroll_status: row.enroll_status ?? "ADMITTED",
      is_active: row.is_active ?? true,
      workflow_status: row.workflow_status ?? "APPROVED",
      student_status: row.student_status ?? "ACTIVE",

      second_language: row.second_language ?? "TELUGU",
      seat_type: row.seat_type ?? "C",
      section: row.section ?? "",

      // Retrieve the personal information from JSON.
      nationality: extraAttributes.nationality ?? "",
      religion: extraAttributes.religion ?? "",
      caste: extraAttributes.caste ?? "",
      subcaste: extraAttributes.subcaste ?? "",

      extra_attributes: extraAttributes,
    }));

    setOpenAddStudent(true);
  };
  const handleCloseAddStudent = () => {
    if (addingStudent) return;

    setOpenAddStudent(false);
  };
  const handleAddStudent = async () => {
    try {
      if (!newStudent.admittedbatch_id) {
        showSnackbar("Please select Admitted Batch", "warning");
        return;
      }

      if (!newStudent.program_id) {
        showSnackbar("Please select Program", "warning");
        return;
      }

      if (!newStudent.branch_id) {
        showSnackbar("Please select Branch", "warning");
        return;
      }

      if (!newStudent.student_rollno.trim()) {
        showSnackbar("Please enter Student Roll Number", "warning");
        return;
      }

      if (!newStudent.student_name.trim()) {
        showSnackbar("Please enter Student Name", "warning");
        return;
      }

      if (newStudent.aadhaar_no && !/^\d{12}$/.test(newStudent.aadhaar_no)) {
        showSnackbar("Aadhaar Number must contain exactly 12 digits", "warning");
        return;
      }

      setAddingStudent(true);

      const payload = {
        ...newStudent,

        admittedbatch_id: Number(newStudent.admittedbatch_id),

        branch_id: Number(newStudent.branch_id),

        program_id: Number(newStudent.program_id),

        user_id: newStudent.user_id ? Number(newStudent.user_id) : null,

        created_by: user?.user_id ? Number(user.user_id) : null,

        transfer_credits:
          newStudent.transfer_credits === "" ? null : Number(newStudent.transfer_credits),

        original_batch_id: newStudent.original_batch_id
          ? Number(newStudent.original_batch_id)
          : null,

        rejoin_batch_id: newStudent.rejoin_batch_id ? Number(newStudent.rejoin_batch_id) : null,
        extra_attributes: {
          nationality: newStudent.nationality || "",
          religion: newStudent.religion || "",
          caste: newStudent.caste || "",
          subcaste: newStudent.subcaste || "",
        },
      };

      const response = isEditMode
        ? await axios.put(
            `${API_BASE_URL}/api/students/updates/${clientId}/${collegeId}/${editingStudentId}`,
            {
              ...payload,
              modified_by: user?.user_email ? String(user.user_email) : null,
            }
          )
        : await axios.post(`${API_BASE_URL}/api/students/add/${clientId}/${collegeId}`, payload);

      if (response.data?.success) {
        showSnackbar(
          isEditMode ? "Student updated successfully" : "Student added successfully",
          "success"
        );

        setOpenAddStudent(false);

        // Capture the selected values before resetting the form.
        const savedBatchId = newStudent.admittedbatch_id;
        const savedProgramId = newStudent.program_id;
        const savedBranchId = newStudent.branch_id;

        resetNewStudent();
        setIsEditMode(false);
        setEditingStudentId(null);

        if (savedBatchId && savedProgramId && savedBranchId) {
          // Keep the filters synchronized with the saved student.
          setAdmittedbatchId(savedBatchId);
          setProgramId(savedProgramId);
          setBranchId(savedBranchId);

          await loadStudents(savedBatchId, savedProgramId, savedBranchId);
        } else {
          setRows([]);
        }
      } else {
        showSnackbar(
          response.data?.message ||
            (isEditMode ? "Unable to update student" : "Unable to add student"),
          "error"
        );
      }
    } catch (error) {
      console.error("Add student error:", error);

      showSnackbar(
        error.response?.data?.message || error.message || "Unable to add student",
        "error"
      );
    } finally {
      setAddingStudent(false);
    }
  };
  const loadAdmittedBatches = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${API_BASE_URL}/api/students/lookups/${clientId}/${collegeId}/admittedbatches`
      );

      if (response.data.success) {
        setAdmittedBatches(response.data.data || []);
      }
    } catch (error) {
      console.error("Error loading admitted batches:", error);

      showSnackbar(error.response?.data?.message || "Unable to load admitted batches", "error");
    } finally {
      setLoading(false);
    }
  };

  // ---------------------------------------------------------
  // WHEN ADMITTED BATCH CHANGES
  // ---------------------------------------------------------
  const handleBatchChange = async (e) => {
    const value = e.target.value;

    setAdmittedbatchId(value);
    setProgramId("");
    setBranchId("");

    setPrograms([]);
    setBranches([]);
    setRows([]);

    if (!value) return;

    try {
      setLoading(true);

      const response = await axios.get(
        `${API_BASE_URL}/api/students/lookups/${clientId}/${collegeId}/programs/${value}`
      );

      if (response.data.success) {
        setPrograms(response.data.data || []);
      }
    } catch (error) {
      console.error("Error loading programs:", error);

      showSnackbar(error.response?.data?.message || "Unable to load programs", "error");
    } finally {
      setLoading(false);
    }
  };

  // ---------------------------------------------------------
  // WHEN PROGRAM CHANGES
  // ---------------------------------------------------------
  const handleProgramChange = async (e) => {
    const value = e.target.value;

    setProgramId(value);
    setBranchId("");

    setBranches([]);
    setRows([]);

    if (!value || !admittedbatchId) return;

    try {
      setLoading(true);

      const response = await axios.get(
        `${API_BASE_URL}/api/students/lookups/${clientId}/${collegeId}/branches/${admittedbatchId}/${value}`
      );

      if (response.data.success) {
        setBranches(response.data.data || []);
      }
    } catch (error) {
      console.error("Error loading branches:", error);

      showSnackbar(error.response?.data?.message || "Unable to load branches", "error");
    } finally {
      setLoading(false);
    }
  };

  // ---------------------------------------------------------
  // WHEN BRANCH CHANGES
  // ---------------------------------------------------------
  const handleBranchChange = async (e) => {
    const value = e.target.value;

    setBranchId(value);
    setRows([]);
    setPage(0);

    if (!value || !admittedbatchId || !programId) return;

    if (admittedbatchId && programId && value) {
      await loadStudents(admittedbatchId, programId, value);
    }
  };

  // ---------------------------------------------------------
  // LOAD STUDENTS
  // ---------------------------------------------------------
  const loadStudents = async (batchId, selectedProgramId, selectedBranchId) => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${API_BASE_URL}/api/students/update-list/${clientId}/${collegeId}/${batchId}/${selectedProgramId}/${selectedBranchId}`
      );

      if (response.data.success) {
        const studentData = response.data.data || [];

        setRows(
          studentData.map((student, index) => {
            const extraAttributes =
              student.extra_attributes &&
              typeof student.extra_attributes === "object" &&
              !Array.isArray(student.extra_attributes)
                ? student.extra_attributes
                : {};

            return {
              id: Number(student.student_id),
              sno: index + 1,
              ...student,
              admission_date: formatDateForInput(student.admission_date),
              dob: formatDateForInput(student.dob),
              nationality: extraAttributes.nationality || "",
              religion: extraAttributes.religion || "",
              caste: extraAttributes.caste || "",
              subcaste: extraAttributes.subcaste || "",
            };
          })
        );
      } else {
        setRows([]);
      }
    } catch (error) {
      console.error("Error loading students:", error);

      setRows([]);

      alert(error.response?.data?.message || "Unable to load students");
    } finally {
      setLoading(false);
    }
  };

  // ---------------------------------------------------------
  // UPDATE ROW VALUE
  // ---------------------------------------------------------
  const updateRowValue = (id, field, value) => {
    setRows((previousRows) =>
      previousRows.map((row) =>
        row.id === id
          ? {
              ...row,
              [field]: value,
            }
          : row
      )
    );
  };

  // ---------------------------------------------------------
  // UPDATE STUDENT
  // ---------------------------------------------------------
  const handleUpdate = async (row) => {
    try {
      setUpdatingId(row.id);
      const payload = {
        admittedbatch_id: row.admittedbatch_id ? Number(row.admittedbatch_id) : null,
        branch_id: row.branch_id ? Number(row.branch_id) : null,
        admission_no: row.admission_no || null,
        admission_date: row.admission_date ? new Date(`${row.admission_date}T00:00:00.000Z`) : null,
        student_rollno: row.student_rollno || null,
        aadhaar_no: row.aadhaar_no || null,
        student_name: row.student_name || null,
        father_name: row.father_name || null,
        mother_name: row.mother_name || null,
        dob: row.dob || null,
        gender: row.gender || null,
        email: row.email || null,
        mobile: row.mobile || null,
        address: row.address || null,
        admission_type: row.admission_type || null,
        second_language: row.second_language || null,
        seat_type: row.seat_type || null,
        section: row.section || null,
        modified_by: user?.user_email || null,
        student_status: row.student_status || "ACTIVE",
        extra_attributes: {
          ...(row.extra_attributes &&
          typeof row.extra_attributes === "object" &&
          !Array.isArray(row.extra_attributes)
            ? row.extra_attributes
            : {}),
          nationality: row.nationality || "",
          religion: row.religion || "",
          caste: row.caste || "",
          subcaste: row.subcaste || "",
        },
      };

      const response = await axios.put(
        `${API_BASE_URL}/api/students/updates/${clientId}/${collegeId}/${row.student_id}`,
        payload
      );

      if (response.data.success) {
        showSnackbar("Student updated successfully", "success");
      } else {
        showSnackbar(response.data?.message || "Unable to update student", "error");
      }
    } catch (error) {
      console.error("Update student error:", error);

      showSnackbar(error.response?.data?.message || "Unable to update student", "error");
    } finally {
      setUpdatingId(null);
    }
  };

  // ---------------------------------------------------------
  // SEARCH
  // ---------------------------------------------------------
  const filteredRows = rows.filter((row) => {
    const search = searchText.toLowerCase().trim();

    if (!search) return true;

    return (
      String(row.student_rollno || "")
        .toLowerCase()
        .includes(search) ||
      String(row.student_name || "")
        .toLowerCase()
        .includes(search) ||
      String(row.admission_no || "")
        .toLowerCase()
        .includes(search) ||
      String(row.aadhaar_no || "")
        .toLowerCase()
        .includes(search) ||
      String(row.father_name || "")
        .toLowerCase()
        .includes(search) ||
      String(row.mother_name || "")
        .toLowerCase()
        .includes(search) ||
      String(row.email || "")
        .toLowerCase()
        .includes(search) ||
      String(row.mobile || "")
        .toLowerCase()
        .includes(search)
    );
  });

  // ---------------------------------------------------------
  // COLUMNS
  // ---------------------------------------------------------
  const columns = [
    {
      field: "edit",
      headerName: "Edit",
      width: 90,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",

      renderCell: (params) => (
        <IconButton
          color="primary"
          aria-label={`Edit ${params.row.student_name || "student"}`}
          onClick={() => handleEditStudent(params.row)}
          disabled={addingStudent || bulkUpdating}
          size="medium"
          sx={{
            border: "1px solid #1976d2",
            borderRadius: 1.5,
            "&:hover": {
              backgroundColor: "rgba(25, 118, 210, 0.10)",
            },
          }}
        >
          <EditIcon />
        </IconButton>
      ),
    },
    {
      field: "sno",
      headerName: "S.No",
      width: 70,
    },

    {
      field: "student_rollno",
      headerName: "Roll No",
      width: 180,

      renderCell: (params) => (
        <TextField
          size="medium"
          fullWidth
          disabled="true"
          value={params.row.student_rollno || ""}
          onChange={(e) => updateRowValue(params.row.id, "student_rollno", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
      ),
    },

    {
      field: "student_name",
      headerName: "Student Name",
      width: 350,

      renderCell: (params) => (
        <TextField
          size="medium"
          fullWidth
          value={params.row.student_name || ""}
          onChange={(e) => updateRowValue(params.row.id, "student_name", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
      ),
    },
    {
      field: "gender",
      headerName: "Gender",
      width: 130,

      renderCell: (params) => (
        <TextField
          select
          size="medium"
          fullWidth
          value={params.row.gender || ""}
          onChange={(e) => updateRowValue(params.row.id, "gender", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          SelectProps={{
            native: true,
          }}
        >
          <option value="">Gender</option>
          <option value="M">M</option>
          <option value="F">F</option>
          <option value="O">O</option>
        </TextField>
      ),
    },
    {
      field: "seat_type",
      headerName: "Seat Type",
      width: 130,

      renderCell: (params) => (
        <TextField
          select
          size="medium"
          fullWidth
          value={params.row.seat_type || ""}
          onChange={(e) => updateRowValue(params.row.id, "seat_type", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          SelectProps={{
            native: true,
          }}
        >
          <option value="">Seat Type</option>
          <option value="C">C</option>
          <option value="M">M</option>
        </TextField>
      ),
    },
    {
      field: "admission_no",
      headerName: "Admission No",
      width: 160,

      renderCell: (params) => (
        <TextField
          size="medium"
          fullWidth
          value={params.row.admission_no || ""}
          onChange={(e) => updateRowValue(params.row.id, "admission_no", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
      ),
    },
    {
      field: "admission_date",
      headerName: "Admission Date",
      width: 160,

      renderCell: (params) => (
        <TextField
          size="medium"
          fullWidth
          type="date"
          value={params.row.admission_date || ""}
          onChange={(e) => updateRowValue(params.row.id, "admission_date", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
      ),
    },
    {
      field: "aadhaar_no",
      headerName: "Aadhaar No",
      width: 180,

      renderCell: (params) => (
        <TextField
          size="medium"
          fullWidth
          value={params.row.aadhaar_no || ""}
          onChange={(e) => updateRowValue(params.row.id, "aadhaar_no", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
      ),
    },
    {
      field: "father_name",
      headerName: "Father Name",
      width: 320,

      renderCell: (params) => (
        <TextField
          size="medium"
          fullWidth
          value={params.row.father_name || ""}
          onChange={(e) => updateRowValue(params.row.id, "father_name", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
      ),
    },

    {
      field: "mother_name",
      headerName: "Mother Name",
      width: 320,

      renderCell: (params) => (
        <TextField
          size="medium"
          fullWidth
          value={params.row.mother_name || ""}
          onChange={(e) => updateRowValue(params.row.id, "mother_name", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
      ),
    },

    {
      field: "dob",
      headerName: "DOB",
      width: 170,

      renderCell: (params) => (
        <TextField
          size="medium"
          type="date"
          fullWidth
          value={params.row.dob ? String(params.row.dob).substring(0, 10) : ""}
          onChange={(e) => updateRowValue(params.row.id, "dob", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
      ),
    },

    {
      field: "email",
      headerName: "Email",
      width: 300,

      renderCell: (params) => (
        <TextField
          size="medium"
          fullWidth
          value={params.row.email || ""}
          onChange={(e) => updateRowValue(params.row.id, "email", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
      ),
    },

    {
      field: "mobile",
      headerName: "Mobile",
      width: 170,

      renderCell: (params) => (
        <TextField
          size="medium"
          fullWidth
          value={params.row.mobile || ""}
          onChange={(e) => updateRowValue(params.row.id, "mobile", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
      ),
    },

    {
      field: "address",
      headerName: "Address",
      width: 300,

      renderCell: (params) => (
        <TextField
          size="medium"
          fullWidth
          value={params.row.address || ""}
          onChange={(e) => updateRowValue(params.row.id, "address", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
      ),
    },

    {
      field: "admission_type",
      headerName: "Admission Type",
      width: 180,

      renderCell: (params) => (
        <TextField
          select
          size="medium"
          fullWidth
          value={params.row.admission_type || ""}
          onChange={(e) => updateRowValue(params.row.id, "admission_type", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          SelectProps={{
            native: true,
          }}
        >
          <option value="">Admission Type</option>
          <option value="REGULAR">REGULAR</option>
          <option value="LATERAL">LATERAL</option>
          <option value="TRANSFER">TRANSFER</option>
          <option value="REJOIN">REJOIN</option>
        </TextField>
      ),
    },

    {
      field: "second_language",
      headerName: "Second Language",
      width: 190,

      renderCell: (params) => (
        <TextField
          select
          size="medium"
          fullWidth
          value={params.row.second_language || ""}
          onChange={(e) => updateRowValue(params.row.id, "second_language", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          SelectProps={{
            native: true,
          }}
        >
          <option value="">Second Language</option>
          <option value="TELUGU">TELUGU</option>
          <option value="HINDI">HINDI</option>
          <option value="SANSKRIT">SANSKRIT</option>
        </TextField>
      ),
    },

    {
      field: "section",
      headerName: "Section",
      width: 130,

      renderCell: (params) => (
        <TextField
          select
          size="medium"
          fullWidth
          value={params.row.section || ""}
          onChange={(e) => updateRowValue(params.row.id, "section", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          SelectProps={{
            native: true,
          }}
        >
          <option value="">Section</option>
          <option value="A">A</option>
          <option value="B">B</option>
          <option value="C">C</option>
          <option value="D">D</option>
          <option value="E">E</option>
        </TextField>
      ),
    },
    {
      field: "nationality",
      headerName: "Nationality",
      width: 170,
      renderCell: (params) => (
        <TextField
          select
          native
          size="medium"
          fullWidth
          value={params.row.nationality || ""}
          onChange={(e) => updateRowValue(params.row.id, "nationality", e.target.value)}
          InputLabelProps={{ shrink: true }}
          SelectProps={{ native: true }}
        >
          <option value="">Select Nationality</option>
          {nationalityOptions.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </TextField>
      ),
    },
    {
      field: "religion",
      headerName: "Religion",
      width: 170,
      renderCell: (params) => (
        <TextField
          select
          size="medium"
          fullWidth
          value={params.row.religion || ""}
          onChange={(e) => updateRowValue(params.row.id, "religion", e.target.value)}
          InputLabelProps={{ shrink: true }}
          SelectProps={{ native: true }}
        >
          <option value="">Select Religion</option>
          {religionOptions.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </TextField>
      ),
    },
    {
      field: "caste",
      headerName: "Caste",
      width: 150,
      renderCell: (params) => (
        <TextField
          select
          size="medium"
          fullWidth
          value={params.row.caste || ""}
          onChange={(e) => {
            updateRowValue(params.row.id, "caste", e.target.value);
            updateRowValue(params.row.id, "subcaste", "");
          }}
          InputLabelProps={{ shrink: true }}
          SelectProps={{ native: true }}
        >
          <option value="">Select Caste</option>
          {casteOptions.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </TextField>
      ),
    },
    {
      field: "subcaste",
      headerName: "Subcaste",
      width: 170,
      renderCell: (params) => (
        <TextField
          select
          size="medium"
          fullWidth
          value={params.row.subcaste || ""}
          onChange={(e) => updateRowValue(params.row.id, "subcaste", e.target.value)}
          InputLabelProps={{ shrink: true }}
          SelectProps={{ native: true }}
        >
          <option value="">Select Subcaste</option>
          {subcasteOptions.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </TextField>
      ),
    },
    {
      field: "student_status",
      headerName: "Student Status",
      width: 180,

      renderCell: (params) => (
        <TextField
          select
          size="medium"
          fullWidth
          value={params.row.student_status || "ACTIVE"}
          onChange={(e) => updateRowValue(params.row.id, "student_status", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          SelectProps={{
            native: true,
          }}
        >
          <option value="ACTIVE">ACTIVE</option>
          <option value="INACTIVE">INACTIVE</option>
          <option value="PASSED_OUT">PASSED OUT</option>
          <option value="DETAINED">DETAINED</option>
          <option value="TCOUT">TCOUT</option>
        </TextField>
      ),
    },
    {
      field: "actions",
      headerName: "Action",
      width: 140,
      sortable: false,
      filterable: false,

      renderCell: (params) => (
        <Button
          variant="contained"
          size="medium"
          disabled={updatingId === params.row.id}
          onClick={() => handleUpdate(params.row)}
          sx={{
            backgroundColor: "#1976d2",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#1565c0",
            },
          }}
        >
          {updatingId === params.row.id ? "Updating..." : "Update"}
        </Button>
      ),
    },
  ];

  return (
    <Box sx={{ p: 2 }}>
      {/* HEADER */}
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            sm: "row",
          },
          alignItems: {
            xs: "stretch",
            sm: "center",
          },
          justifyContent: "space-between",
          gap: 2,
          mb: 2,
          width: "100%",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            fontSize: {
              xs: "20px",
              sm: "24px",
            },
            whiteSpace: "nowrap",
          }}
        >
          UPDATE STUDENTS
        </Typography>

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleOpenAddStudent}
          sx={{
            width: {
              xs: "100%",
              sm: "auto",
            },
            minHeight: 40,
            backgroundColor: "#1976d2",
            color: "#fff",
            fontWeight: "bold",
            minWidth: 140,
            "&:hover": {
              backgroundColor: "#1565c0",
            },
          }}
        >
          Add Student
        </Button>
        <Button
          variant="contained"
          onClick={handleBulkUpdate}
          disabled={bulkUpdating || loading || rows.length === 0}
          sx={{
            width: { xs: "100%", sm: "auto" },
            minHeight: 40,
            backgroundColor: "#2e7d32",
            color: "#fff",
            fontWeight: "bold",
            minWidth: 150,
            "&:hover": {
              backgroundColor: "#1b5e20",
            },
          }}
        >
          {bulkUpdating ? "Updating..." : "Bulk Update"}
        </Button>
      </Box>
      {/* FILTERS */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          mb: 2,
          alignItems: "center",
        }}
      >
        {/* ADMITTED BATCH */}
        <TextField
          select
          label="Admitted Batch"
          size="medium"
          value={admittedbatchId}
          onChange={handleBatchChange}
          InputLabelProps={{
            shrink: true,
          }}
          SelectProps={{
            native: true,
          }}
          sx={{
            width: {
              xs: "100%",
              sm: 220,
            },
          }}
        >
          <option value="">Admitted Batch</option>

          {admittedBatches.map((batch) => (
            <option key={batch.admittedbatch_id} value={batch.admittedbatch_id}>
              {batch.admittedbatch}
            </option>
          ))}
        </TextField>

        {/* PROGRAM */}
        <TextField
          select
          label="Program"
          size="medium"
          value={programId}
          onChange={handleProgramChange}
          disabled={!admittedbatchId}
          InputLabelProps={{
            shrink: true,
          }}
          SelectProps={{
            native: true,
          }}
          sx={{
            width: {
              xs: "100%",
              sm: 280,
            },
          }}
        >
          <option value="">Select Program</option>

          {programs.map((program) => (
            <option key={program.program_id} value={program.program_id}>
              {program.program_name}
            </option>
          ))}
        </TextField>

        {/* BRANCH */}
        <TextField
          select
          label="Branch"
          size="medium"
          value={branchId}
          onChange={handleBranchChange}
          disabled={!programId}
          InputLabelProps={{
            shrink: true,
          }}
          SelectProps={{
            native: true,
          }}
          sx={{
            width: {
              xs: "100%",
              sm: 300,
            },
          }}
        >
          <option value="">Select Branch</option>

          {branches.map((branch) => (
            <option key={branch.branch_id} value={branch.branch_id}>
              {branch.branch_name}
            </option>
          ))}
        </TextField>
        <TextField
          size="medium"
          placeholder="Search Roll No, Name, Admission No, Aadhaar, Email, Mobile"
          value={searchText}
          onChange={(e) => {
            setSearchText(e.target.value);
            setPage(0);
          }}
          sx={{
            width: {
              xs: "100%",
              sm: 400,
              md: 500,
            },
            "& .MuiInputBase-input": {
              fontSize: {
                xs: "14px",
                sm: "16px",
              },
            },
          }}
        />
      </Box>
      {/* DATAGRID */}
      <Box
        sx={{
          height: 650,
          width: "100%",
        }}
      >
        <DataGrid
          rows={filteredRows}
          columns={columns}
          page={page}
          pageSize={pageSize}
          onPageChange={(newPage) => setPage(newPage)}
          onPageSizeChange={(newPageSize) => {
            setPageSize(newPageSize);
            setPage(0);
          }}
          rowsPerPageOptions={[10, 25, 50, 100]}
          pagination
          loading={loading}
          disableSelectionOnClick
          sx={{
            "& .MuiInputBase-input": {
              fontSize: "16px",
            },

            "& .MuiSelect-select": {
              fontSize: "16px",
            },

            "& .MuiMenuItem-root": {
              fontSize: "16px",
            },

            "& .MuiInputLabel-root": {
              fontSize: "16px",
            },

            "& .MuiDataGrid-cell": {
              fontSize: "16px",
            },

            "& .MuiDataGrid-columnHeaderTitle": {
              fontSize: "16px",
              fontWeight: 600,
            },
          }}
        />
      </Box>
      <Dialog
        open={openAddStudent}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
          handleCloseAddStudent();
        }}
        disableEscapeKeyDown
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontWeight: "bold",
            bgcolor: "#1976d2",
            color: "#fff",
            py: 1.5,
          }}
        >
          {isEditMode ? "Edit Student" : "Add New Student"}
          <IconButton
            onClick={handleCloseAddStudent}
            disabled={addingStudent}
            sx={{
              color: "#fff",
              "&:hover": {
                bgcolor: "rgba(255,255,255,0.15)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            {/* =========================
          ACADEMIC INFORMATION
      ========================== */}

            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "bold",
                  mb: 1,
                }}
              >
                Academic Information
              </Typography>
            </Grid>

            {/* Admitted Batch */}
            <Grid item xs={12} md={4}>
              <TextField
                select
                fullWidth
                size="medium"
                label="Admitted Batch"
                value={newStudent.admittedbatch_id}
                onChange={async (e) => {
                  const value = e.target.value;

                  handleNewStudentChange("admittedbatch_id", value);

                  handleNewStudentChange("program_id", "");

                  handleNewStudentChange("branch_id", "");

                  if (value) {
                    try {
                      const response = await axios.get(
                        `${API_BASE_URL}/api/students/lookups/${clientId}/${collegeId}/programs/${value}`
                      );

                      setPrograms(response.data?.data || []);
                    } catch (error) {
                      console.error("Unable to load programs:", error);
                      alert(error.response?.data?.message || "Unable to load programs");
                    }
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                SelectProps={{
                  native: true,
                }}
              >
                <option value="">Select Admitted Batch</option>

                {admittedBatches.map((item) => (
                  <option key={item.admittedbatch_id} value={item.admittedbatch_id}>
                    {item.admittedbatch}
                  </option>
                ))}
              </TextField>
            </Grid>

            {/* Program */}
            <Grid item xs={12} md={4}>
              <TextField
                select
                fullWidth
                size="medium"
                label="Program"
                value={newStudent.program_id}
                onChange={async (e) => {
                  const value = e.target.value;

                  handleNewStudentChange("program_id", value);

                  handleNewStudentChange("branch_id", "");

                  if (value && newStudent.admittedbatch_id) {
                    try {
                      const response = await axios.get(
                        `${API_BASE_URL}/api/students/lookups/${clientId}/${collegeId}/branches/${newStudent.admittedbatch_id}/${value}`
                      );

                      setBranches(response.data?.data || []);
                    } catch (error) {
                      console.error("Unable to load branches:", error);

                      alert(error.response?.data?.message || "Unable to load branches");
                    }
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                SelectProps={{
                  native: true,
                }}
              >
                <option value="">Select Program</option>

                {programs.map((item) => (
                  <option key={item.program_id} value={item.program_id}>
                    {item.program_name}
                  </option>
                ))}
              </TextField>
            </Grid>

            {/* Branch */}
            <Grid item xs={12} md={4}>
              <TextField
                select
                fullWidth
                size="medium"
                label="Branch"
                value={newStudent.branch_id}
                onChange={(e) => handleNewStudentChange("branch_id", e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                SelectProps={{
                  native: true,
                }}
              >
                <option value="">Select Branch</option>

                {branches.map((item) => (
                  <option key={item.branch_id} value={item.branch_id}>
                    {item.branch_name}
                  </option>
                ))}
              </TextField>
            </Grid>

            {/* =========================
          STUDENT INFORMATION
      ========================== */}

            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "bold",
                  mt: 1,
                  mb: 1,
                }}
              >
                Student Information
              </Typography>
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="medium"
                label="Student Roll Number"
                value={newStudent.student_rollno}
                onChange={(e) => handleNewStudentChange("student_rollno", e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                required
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="medium"
                label="Admission Number"
                value={newStudent.admission_no}
                onChange={(e) => handleNewStudentChange("admission_no", e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="medium"
                label="Admission Date"
                type="date"
                value={newStudent.admission_date}
                onChange={(e) => handleNewStudentChange("admission_date", e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="medium"
                label="Student Name"
                value={newStudent.student_name}
                onChange={(e) => handleNewStudentChange("student_name", e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                required
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="medium"
                label="Father Name"
                value={newStudent.father_name}
                onChange={(e) => handleNewStudentChange("father_name", e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="medium"
                label="Mother Name"
                value={newStudent.mother_name}
                onChange={(e) => handleNewStudentChange("mother_name", e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="medium"
                label="Aadhaar Number"
                value={newStudent.aadhaar_no}
                onChange={(e) =>
                  handleNewStudentChange("aadhaar_no", e.target.value.replace(/\D/g, ""))
                }
                inputProps={{
                  maxLength: 12,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="medium"
                label="Date of Birth"
                type="date"
                value={newStudent.dob}
                onChange={(e) => handleNewStudentChange("dob", e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                select
                fullWidth
                size="medium"
                label="Gender"
                value={newStudent.gender}
                onChange={(e) => handleNewStudentChange("gender", e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                SelectProps={{
                  native: true,
                }}
              >
                <option value="M">Male</option>
                <option value="F">Female</option>
                <option value="O">Other</option>
              </TextField>
            </Grid>
            {/* =========================
    PERSONAL / COMMUNITY INFORMATION
========================== */}

            <Grid item xs={12}>
              <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1, mb: 1 }}>
                Personal Information
              </Typography>
            </Grid>

            {/* Nationality */}
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                select
                fullWidth
                size="medium"
                label="Nationality"
                value={newStudent.nationality || ""}
                onChange={(e) => handleNewStudentChange("nationality", e.target.value)}
                InputLabelProps={{ shrink: true }}
                SelectProps={{ native: true }}
              >
                <option value="">Select Nationality</option>
                {nationalityOptions.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </TextField>
            </Grid>

            {/* Religion */}
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                select
                fullWidth
                size="medium"
                label="Religion"
                value={newStudent.religion || ""}
                onChange={(e) => {
                  handleNewStudentChange("religion", e.target.value);
                }}
                InputLabelProps={{ shrink: true }}
                SelectProps={{ native: true }}
              >
                <option value="">Select Religion</option>
                {religionOptions.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </TextField>
            </Grid>

            {/* Caste */}
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                select
                fullWidth
                size="medium"
                label="Caste"
                value={newStudent.caste || ""}
                onChange={(e) => {
                  const value = e.target.value;

                  handleNewStudentChange("caste", value);
                  handleNewStudentChange("subcaste", "");
                }}
                InputLabelProps={{ shrink: true }}
                SelectProps={{ native: true }}
              >
                <option value="">Select Caste</option>
                {casteOptions.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </TextField>
            </Grid>

            {/* Subcaste */}
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                size="medium"
                label="Subcaste"
                value={newStudent.subcaste || ""}
                onChange={(e) => handleNewStudentChange("subcaste", e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            {/* =========================
          CONTACT
      ========================== */}

            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "bold",
                  mt: 1,
                  mb: 1,
                }}
              >
                Contact Information
              </Typography>
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="medium"
                label="Email"
                type="email"
                value={newStudent.email}
                onChange={(e) => handleNewStudentChange("email", e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="medium"
                label="Mobile"
                value={newStudent.mobile}
                onChange={(e) => handleNewStudentChange("mobile", e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} md={8}>
              <TextField
                fullWidth
                size="medium"
                label="Address"
                multiline
                minRows={2}
                value={newStudent.address}
                onChange={(e) => handleNewStudentChange("address", e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            {/* =========================
          ADMISSION
      ========================== */}

            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "bold",
                  mt: 1,
                  mb: 1,
                }}
              >
                Admission Details
              </Typography>
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                select
                fullWidth
                size="medium"
                label="Admission Type"
                value={newStudent.admission_type}
                onChange={(e) => handleNewStudentChange("admission_type", e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                SelectProps={{
                  native: true,
                }}
              >
                <option value="REGULAR">Regular</option>
                <option value="LATERAL">Lateral</option>
                <option value="TRANSFER">Transfer</option>
                <option value="REJOIN">Rejoin</option>
              </TextField>
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                select
                fullWidth
                size="medium"
                label="Second Language"
                value={newStudent.second_language}
                onChange={(e) => handleNewStudentChange("second_language", e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                SelectProps={{
                  native: true,
                }}
              >
                <option value="TELUGU">Telugu</option>
                <option value="HINDI">Hindi</option>
                <option value="SANSKRIT">Sanskrit</option>
              </TextField>
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                select
                fullWidth
                size="medium"
                label="Seat Type"
                value={newStudent.seat_type}
                onChange={(e) => handleNewStudentChange("seat_type", e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                SelectProps={{
                  native: true,
                }}
              >
                <option value="C">C</option>
                <option value="M">M</option>
              </TextField>
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                size="medium"
                label="Section"
                value={newStudent.section}
                onChange={(e) => handleNewStudentChange("section", e.target.value.toUpperCase())}
                inputProps={{
                  maxLength: 2,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            {/* =========================
          TRANSFER / REJOIN
      ========================== */}

            {newStudent.admission_type === "TRANSFER" && (
              <>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    size="medium"
                    label="Previous College"
                    value={newStudent.previous_college}
                    onChange={(e) => handleNewStudentChange("previous_college", e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    size="medium"
                    label="Transfer Date"
                    type="date"
                    value={newStudent.transfer_date}
                    onChange={(e) => handleNewStudentChange("transfer_date", e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    size="medium"
                    label="Transfer Credits"
                    type="number"
                    value={newStudent.transfer_credits}
                    onChange={(e) => handleNewStudentChange("transfer_credits", e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </>
            )}

            {newStudent.admission_type === "REJOIN" && (
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  size="medium"
                  label="Break Reason"
                  value={newStudent.break_reason}
                  onChange={(e) => handleNewStudentChange("break_reason", e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            )}

            {/* =========================
          STATUS
      ========================== */}

            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "bold",
                  mt: 1,
                  mb: 1,
                }}
              >
                Status
              </Typography>
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                select
                fullWidth
                size="medium"
                label="Enrollment Status"
                value={newStudent.enroll_status}
                onChange={(e) => handleNewStudentChange("enroll_status", e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                SelectProps={{
                  native: true,
                }}
              >
                <option value="ADMITTED">Admitted</option>
                <option value="ENROLLED">Enrolled</option>
                <option value="DROPPED">Dropped</option>
              </TextField>
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                select
                fullWidth
                size="medium"
                label="Student Status"
                value={newStudent.student_status}
                onChange={(e) => handleNewStudentChange("student_status", e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                SelectProps={{
                  native: true,
                }}
              >
                <option value="ACTIVE">Active</option>
                <option value="INACTIVE">Inactive</option>
                <option value="PASSED_OUT">Passed Out</option>
                <option value="DETAINED">Detained</option>
                <option value="TCOUT">TC Out</option>
              </TextField>
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                select
                fullWidth
                size="medium"
                label="Workflow Status"
                value={newStudent.workflow_status}
                onChange={(e) => handleNewStudentChange("workflow_status", e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                SelectProps={{
                  native: true,
                }}
              >
                <option value="DRAFT">Draft</option>
                <option value="APPROVED">Approved</option>
                <option value="INACTIVE">Inactive</option>
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            variant="contained"
            startIcon={<CloseIcon />}
            onClick={handleCloseAddStudent}
            disabled={addingStudent}
            sx={{
              backgroundColor: "#d32f2f",
              color: "#fff",
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "#b71c1c",
              },
              "&.Mui-disabled": {
                backgroundColor: "#ef9a9a",
                color: "#fff",
              },
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={handleAddStudent}
            disabled={addingStudent}
            sx={{
              backgroundColor: "#1976d2",
              color: "#fff",
              fontWeight: "bold",
              minWidth: 140,
              "&:hover": {
                backgroundColor: "#1565c0",
              },
            }}
          >
            {addingStudent
              ? isEditMode
                ? "Updating..."
                : "Saving..."
              : isEditMode
              ? "Update Student"
              : "Save Student"}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          variant="filled"
          sx={{
            width: "100%",
            fontSize: "15px",
            fontWeight: 600,
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
